import { useState } from "react";
import { shortenAddress } from '@usedapp/core';
import { useEthers } from '@usedapp/core';
import {isMobile} from 'react-device-detect';
import { AccountModal } from "./AccountModal";
import { WalletsModal } from "./WalletsModal";

interface ChainProps {
  account?: string,
  chainId?: number
}

export const AccountButton: React.FC<ChainProps> = ({account}) => {

  const { activateBrowserWallet } = useEthers();

  const connectButton = document.getElementsByClassName('header__button')[0].getElementsByTagName("a")[0];
  connectButton.target = '_self';
  connectButton.href = "#";
  
  const [accountModalOpen, setAccountModalOpen] = useState(false);
  const [walletModalOpen, setWalletModalOpen] = useState(false);

  const onAccountModalOpen = () => {
    setAccountModalOpen(true);
  };

  const onWalletModalOpen = () => {
    setWalletModalOpen(true);
  };

  if(account){
    connectButton.innerHTML = shortenAddress(account);
    connectButton.onclick = (event) => { 
      event.preventDefault(); 
      onAccountModalOpen();
    }
  } else {
    connectButton.innerHTML = 'Connect Wallet';
    connectButton.onclick = (event) => {
      event.preventDefault();
      isMobile ? activateBrowserWallet({ type: 'walletConnectV2' }) : onWalletModalOpen();
    }
  }    
   

  if (account) {
    return (
      <>
         <AccountModal open={accountModalOpen} onClose={() => setAccountModalOpen(false)} />
      </>
    )
  }

  return (
    <>
      <WalletsModal open={walletModalOpen} onClose={() => setWalletModalOpen(false)} />
    </>
  )
};